/* eslint-disable react/prop-types */
import React from 'react';
import {
  formatDate, showTodayOrTomorrow, showDateOrDateRange, getPreferredFfmFromAPI
} from '../../../components/helper/utils';
import {
  formatSellableQuantity
} from '../../helpers/pod-fulfillment-utils';
import { IDS } from '../../../automationTestIds';

const getDateText = (startDate, endDate, deliveryTimeline) => {
  const formattedStartDate = startDate && formatDate(startDate, false);
  const formattedEndDate = endDate && formatDate(endDate, false);

  if (endDate && startDate === endDate) {
    return showTodayOrTomorrow(endDate, true, deliveryTimeline, formattedEndDate, false);
  }

  return showDateOrDateRange({ formattedStartDate, formattedEndDate });
};

const renderMainContent = ({
  isDeliveryFree,
  showQuantity,
  showAvailableText,
  formattedQty,
  dateText,
  enablePLPFasterDeliveryOption
}) => {
  const renderPipeSeparator = () => <span>{' | '}</span>;
  const renderAvailable = () => <span className="sui-text-primary">Available</span>;
  const renderQuantity = () => (
    <>
      <span className="sui-text-success" data-automation-id={IDS.QTY.deliveryQty}>{`${formattedQty} `}</span>
      <span className="sui-text-primary">{enablePLPFasterDeliveryOption ? 'avail' : 'available'}</span>
    </>
  );

  const renderDateDisplay = () => {
    if (!dateText) return null;
    return (
      <>
        {(!enablePLPFasterDeliveryOption && (isDeliveryFree || showQuantity)) && renderPipeSeparator()}
        <span className="sui-text-primary" data-automation-id={IDS.ETA.deliveryETA}>{dateText}</span>
      </>
    );
  };

  const showPipeSeparator = isDeliveryFree && (showQuantity || showAvailableText);
  const dateDelimiter = dateText && isDeliveryFree;
  const quantityDelimiter = showQuantity && (dateText || isDeliveryFree);

  // Free | Today | 1 avail
  if (enablePLPFasterDeliveryOption) {
    return (
      <span className="gap-x-1 whitespace-nowrap">
        {isDeliveryFree && <span className="sui-text-success">Free</span>}
        {dateDelimiter && renderPipeSeparator()}
        {renderDateDisplay()}
        {quantityDelimiter && renderPipeSeparator()}
        {showQuantity && renderQuantity()}
        {!isDeliveryFree && showAvailableText && renderAvailable()}
      </span>
    );
  }

  // sample format - Free | Today
  return (
    <>
      {isDeliveryFree && <span className="sui-text-success">Free</span>}
      {showPipeSeparator && renderPipeSeparator()}
      {showQuantity && renderQuantity()}
      {showAvailableText && renderAvailable()}
      {renderDateDisplay()}
    </>
  );
};

export const getPLPSpeedTemplate = ({ product, displayQuantity , enablePLPFasterDeliveryOption, hideFreeDelivery }) => {
  const optimalPodFulfillment = getPreferredFfmFromAPI(product?.fulfillment, false, false, true);
  const { deliveryDates, deliveryTimeline, totalCharge } = optimalPodFulfillment || {};
  const isDeliveryFree = totalCharge === 0 && !hideFreeDelivery;
  const { startDate, endDate } = deliveryDates || {};

  const isResiliencyScenario = !endDate && totalCharge === null;
  if (isResiliencyScenario) {
    // FFA resiliency, isInStock is already checked in previous conditions
    return <span className="sui-text-primary">Available</span>;
  }

  const dateText = getDateText(startDate, endDate, deliveryTimeline);
  const showQuantity = displayQuantity > 0;
  const formattedQty = formatSellableQuantity(displayQuantity);
  const showAvailableText = (!dateText && !showQuantity);

  return renderMainContent({
    isDeliveryFree,
    showQuantity,
    showAvailableText,
    formattedQty,
    dateText,
    enablePLPFasterDeliveryOption
  });
};